// Matches runs of 2+ whitespace characters. Used to collapse the gap left
// behind after stripping a color word out of the middle of a title.
export const MULTI_SPACE = /\s{2,}/g;
